import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withErrorHandling, withLoader } from '@/store/thunks/thunkWrappers';
import type { ExternalUserDTO } from '@/types/external-users.types';

export const fetchExternalUsersThunk = createAppAsyncThunk<ExternalUserDTO[]>(
  'externalUsers/fetchExternalUsers',
  withLoader(withErrorHandling(async (_, { extra }) => await extra.userService.listExternalUsers()))
);
